import BudgetShow from "../Components/BudgetShow";

function Show() {
    return (
        <BudgetShow />
    );
}

export default Show;